import React from 'react';

import { featureKeys } from 'services/FeatureFlagService';

import OldSideBar from './sidebar_V1';
import NewSideBar from './sideBar_V2';
import NewUXSideBar from './sideBar_V3';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';

/**
 * Based on Feature Flag determine which sidebar to render
 *  * @param {} props 
 * @returns 
 */
const WorkspaceSideBar = ({getFeatureFlagValue, ...props}) => {
  const isRedesignedWorkspace = getFeatureFlagValue(featureKeys.WORKSPACE_REDESIGN);
  const isRedesignedWorkspaceNew = getFeatureFlagValue(featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22);

  if(isRedesignedWorkspaceNew) {
    return <NewUXSideBar {...props} />;
  }

  return (isRedesignedWorkspace ? <NewSideBar {...props} /> : <OldSideBar {...props}/>);
};

const flagNames = [featureKeys.WORKSPACE_REDESIGN, featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22];
export default enhanceWithFeatureFlagSubscription(WorkspaceSideBar, flagNames);